var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.702,
    height: 55.664,
    viewBox: "0 0 61.702 55.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.286 -7.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.274,63.077c-2.262,0-4.525.006-6.787,0-3.928-.013-5.248-2.233-3.335-5.628Q23.419,37.439,34.7,17.438c1.473-2.612,2.921-5.238,4.433-7.827,1.7-2.914,4.448-2.922,6.109-.021,2.589,4.519,5.117,9.073,7.721,13.583a3.9,3.9,0,0,1-.01,4.3q-9.96,16.846-19.873,33.72a3.59,3.59,0,0,1-3.388,1.888c-2.473-.025-4.946-.007-7.419,0Z",
    transform: "translate(0)",
    fill: "#504c4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.835,133.859c-2.947,0-5.894.028-8.841-.008-3.088-.037-4.5-2.346-3.017-5.046q4.365-7.957,8.871-15.837c1.612-2.817,4.451-2.782,6.063.033q4.433,7.739,8.8,15.517c1.692,3.017.3,5.318-3.189,5.34-2.894.018-5.789,0-8.683,0Z",
    transform: "translate(-79.439 -70.785)",
    fill: "#504c4c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.bdc30e724c133703d59ee6fad792ed86.svg";
export { ForwardRef as ReactComponent };